import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { StepsSection } from './components/StepsSection';
import { SplitSection } from './components/SplitSection';
import { DifferenceSection } from './components/DifferenceSection';
import { WaitlistSection } from './components/WaitlistSection';
import { Footer } from './components/Footer';
import { ElephantMascot } from './components/ElephantMascot';
import { Button } from './components/common/Button';
import { Star, Circle, Triangle } from 'lucide-react';
export function App() {
  return <div className="min-h-screen bg-white text-[#1A1A1A] font-sans selection:bg-[#FFFC00] selection:text-[#1A1A1A]" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofSection data-id="element-4" />
        <StepsSection data-id="element-5" />

        {/* Invite Only Mascot Section */}
        <section className="bg-[#FFFC00] py-16 border-y-4 border-[#1A1A1A] relative overflow-hidden z-20 flex items-center justify-center" data-id="element-6">
          <div className="relative z-10 w-full max-w-sm mx-auto px-4 mt-12" data-id="element-7">
            {/* Tightly Packed Question Pills - Left Side */}
            <div className="hidden lg:block absolute right-[100%] top-[10%] w-64 -mr-8 z-20" data-id="element-8">
              <div className="bg-white border-4 border-[#1A1A1A] rounded-full py-3 px-6 shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transform -rotate-6 hover:rotate-0 hover:scale-105 transition-all cursor-pointer" data-id="element-9">
                <p className="font-bold text-[#1A1A1A] text-center" data-id="element-10">
                  Wait, how do I get an invite?
                </p>
              </div>
            </div>
            <div className="hidden lg:block absolute right-[100%] top-[40%] w-56 -mr-4 z-0" data-id="element-11">
              <div className="bg-[#D4F57A] border-4 border-[#1A1A1A] rounded-full py-3 px-6 shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transform rotate-3 hover:rotate-0 hover:scale-105 transition-all cursor-pointer" data-id="element-12">
                <p className="font-bold text-[#1A1A1A] text-center" data-id="element-13">
                  Is it really free?
                </p>
              </div>
            </div>
            <div className="hidden lg:block absolute right-[100%] bottom-[10%] w-72 -mr-12 z-20" data-id="element-14">
              <div className="bg-white border-4 border-[#1A1A1A] rounded-full py-3 px-6 shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transform -rotate-2 hover:rotate-0 hover:scale-105 transition-all cursor-pointer" data-id="element-15">
                <p className="font-bold text-[#1A1A1A] text-center" data-id="element-16">
                  Can I invite my friends?
                </p>
              </div>
            </div>

            {/* Tightly Packed Question Pills - Right Side */}
            <div className="hidden lg:block absolute left-[100%] top-[5%] w-60 -ml-6 z-0" data-id="element-17">
              <div className="bg-white border-4 border-[#1A1A1A] rounded-full py-3 px-6 shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transform rotate-8 hover:rotate-0 hover:scale-105 transition-all cursor-pointer" data-id="element-18">
                <p className="font-bold text-[#1A1A1A] text-center" data-id="element-19">
                  What kind of perks?
                </p>
              </div>
            </div>
            <div className="hidden lg:block absolute left-[100%] top-[35%] w-64 -ml-10 z-20" data-id="element-20">
              <div className="bg-[#FF90E8] border-4 border-[#1A1A1A] rounded-full py-3 px-6 shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transform -rotate-4 hover:rotate-0 hover:scale-105 transition-all cursor-pointer" data-id="element-21">
                <p className="font-bold text-[#1A1A1A] text-center" data-id="element-22">
                  Why is it invite-only?
                </p>
              </div>
            </div>
            <div className="hidden lg:block absolute left-[100%] bottom-[15%] w-56 -ml-4 z-0" data-id="element-23">
              <div className="bg-white border-4 border-[#1A1A1A] rounded-full py-3 px-6 shadow-[4px_4px_0px_0px_rgba(26,26,26,1)] transform rotate-2 hover:rotate-0 hover:scale-105 transition-all cursor-pointer" data-id="element-24">
                <p className="font-bold text-[#1A1A1A] text-center" data-id="element-25">
                  Where can I use it?
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center relative z-10" data-id="element-26">
              <ElephantMascot size="md" direction="right" className="mb-6 hover:scale-110 transition-transform duration-300" data-id="element-27" />
              <div className="bg-[#1A1A1A] text-white p-8 rounded-[2rem] shadow-[8px_8px_0px_0px_rgba(255,252,0,1)] border-4 border-[#1A1A1A] w-full relative" data-id="element-28">
                {/* Speech bubble pointer pointing up to elephant */}
                <div className="absolute -top-6 left-1/2 -translate-x-1/2 w-0 h-0 border-l-[15px] border-l-transparent border-r-[15px] border-r-transparent border-b-[24px] border-b-[#1A1A1A]" data-id="element-29"></div>

                <h3 className="text-2xl font-black mb-3 leading-tight" data-id="element-30">
                  This is an exclusive club.
                </h3>
                <p className="text-base text-gray-300 font-medium mb-6" data-id="element-31">
                  Kraya is currently invite-only. Get your private invitation
                  code to unlock the app.
                </p>
                <Button variant="primary" size="lg" href="https://kraya.live/" className="text-lg py-3 px-8 w-full shadow-[4px_4px_0px_0px_rgba(255,255,255,0.2)] hover:shadow-none hover:translate-y-1 transition-all" data-id="element-32">
                  Get Invite Code
                </Button>
              </div>
            </div>
          </div>
        </section>

        <SplitSection data-id="element-33" />
        <DifferenceSection data-id="element-34" />
        <WaitlistSection data-id="element-35" />
      </main>
      <Footer data-id="element-36" />
    </div>;
}